var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whats-app-bottom",attrs:{"id":"whats-app-bottom"}},[_c('a',{attrs:{"href":_vm.whatsapplink,"target":"_blank"}},[_c('img',{staticClass:"img-flip-on-rtl whats-app",attrs:{"src":"/images/whatsapp1.png","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }